/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirstClip
 */
export interface FirstClip {
    /**
     * 初回クリップ作成済みか
     * @type {boolean}
     * @memberof FirstClip
     */
    isCreatedFirstClip: boolean;
}

export function FirstClipFromJSON(json: any): FirstClip {
    return FirstClipFromJSONTyped(json, false);
}

export function FirstClipFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirstClip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCreatedFirstClip': json['is_created_first_clip'],
    };
}

export function FirstClipToJSON(value?: FirstClip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_created_first_clip': value.isCreatedFirstClip,
    };
}

